import { FC } from "react";
import { Checkbox, Space, Stack } from "@mantine/core";

import { UnstyledSelect } from "@shared/components";
import { useNangoIssueTypeProjects } from "@shared/hooks";

export interface CreateTicketCheckboxProps {
  integrationName?: string;
  isConfigured?: boolean;
  isV3Integration?: boolean;
  numFindingsToTriage: number;
  createTicketChecked: boolean;
  setCreateTicketChecked: (e: boolean) => void;
  multiIssueTickets: boolean;
  setMultiIssueTickets: (e: boolean) => void;
  hasMultiIssueTicketsAvailable: boolean;
  projectId?: string;
  setProjectId: (projectId: string) => void;
}

const GROUPED_VALUE = "grouped";
const UNGROUPED_VALUE = "individual";

export const CreateTicketCheckbox: FC<CreateTicketCheckboxProps> = ({
  integrationName,
  isConfigured,
  isV3Integration,
  numFindingsToTriage,
  createTicketChecked,
  setCreateTicketChecked,
  hasMultiIssueTicketsAvailable,
  multiIssueTickets,
  setMultiIssueTickets,
  projectId,
  setProjectId,
}) => {
  const { data: projects, isLoading } = useNangoIssueTypeProjects();

  let multiIssueTicketSelect = null;
  if (hasMultiIssueTicketsAvailable && numFindingsToTriage > 1) {
    multiIssueTicketSelect = (
      <>
        <span>for </span>
        <UnstyledSelect
          withinPortal={false}
          value={multiIssueTickets ? GROUPED_VALUE : UNGROUPED_VALUE}
          onChange={(value) => {
            setMultiIssueTickets(value === GROUPED_VALUE);
          }}
          data={[
            {
              label: "groups of findings",
              value: GROUPED_VALUE,
              // Keep this in-sync with MAX_ISSUES_PER_TICKET on backend
              description: "by project and rule, up to 50 findings per ticket",
            },
            { label: "each finding", value: UNGROUPED_VALUE },
          ]}
        />
      </>
    );
  }

  const projectSelect = isV3Integration ? (
    <UnstyledSelect
      withinPortal={false}
      value={projectId ?? ""}
      onChange={(value) => setProjectId(value || "")}
      data={projects ?? []}
      isLoading={isLoading}
    />
  ) : null;

  if (!integrationName || !isConfigured) {
    return null;
  }

  return (
    <Stack gap={8}>
      <Space h="4" />
      <Checkbox
        checked={createTicketChecked}
        onChange={(e) => setCreateTicketChecked(e.currentTarget.checked)}
        size="xs"
        label={
          <div>
            <span>Create tickets </span>
            {multiIssueTicketSelect}
            <span>in {integrationName} project </span>
            {projectSelect}
          </div>
        }
      />
    </Stack>
  );
};
